import React, { useState, useEffect, Fragment } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { useFormContext } from 'react-hook-form';
import marketing from '../../../services/marketing';
import { tcGenerator } from '../../../services/tcGenerator';
import ErrorModal from '../../body/forms/components/ErrorModal'
import '../../../assets/terms/applicantdisclosure.css';
import AxiosWrapper from '../../../services/axios';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


function TC({ data, onTermsErrorChange  }) {
    const [pdfBase64, setPdfBase64] = useState(null);
    const [loading, setLoading] = useState(true);
    const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
    const productCode = data.productCode;
    const { register, formState: { errors } } = useFormContext();
    const utm = new marketing();
    const setInfo = useStoreActions(actions => actions.applicantModel.setApplicant);
    const info = useStoreState((state) => state.applicantModel.applicant);
    const activeCheck = useStoreState((state) => state.siteSettingsModel.activateChecks);
    const [errorShow, setErrorShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const closeError = () => setErrorShow(false);
    const client = new AxiosWrapper();
    const [numPages, setNumPages] = useState(0);


 

    useEffect(() => {
        const handleSuccess = ({ fileContent, hasErrors, errorMessage }) => {
            if (fileContent !== null && !hasErrors) {
                setPdfBase64(fileContent);
                onTermsErrorChange(false);
                return;
            }
            setErrorMessage(errorMessage);
            setErrorShow(true);
            setPdfBase64(null);
            onTermsErrorChange (true);
        };
    
        const handleError = (err) => {
            setErrorMessage(err.message || "Unknown Error");
            setErrorShow(true);
            setPdfBase64(null);
            onTermsErrorChange (true);
        };
    
        setLoading(true);
    
        tcGenerator(productCode)
            .then(handleSuccess)
            .catch(handleError)
            .finally(() => setLoading(false));
    
        localStorage.setItem("TCProductCode", productCode);
    
    }, [productCode]);  

    function downloadPdf(pdfBase64, filename = "terms_and_conditions.pdf") {
      
        const byteCharacters = atob(pdfBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
      
      
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      
     
      }
    const handleRetry = () => {
        setErrorShow(false);
        window.location.reload();
      };

    return (
        <Fragment>
            <ErrorModal size='sm' show={errorShow} message={errorMessage} closeError={closeError} onRetry={handleRetry} />
            <div className='row'>
                <div className='col-12'>
                    <div id="applicant-disclosure"
                    >
                        {loading && <div>Loading Terms and Conditions...</div>}
                        {!loading && pdfBase64 && (!client.isMobile() && !client.isTablet()) && (
                           
                                <iframe
                                    title="Terms and Conditions PDF"
                                    src={`data:application/pdf;base64,${pdfBase64}#toolbar=0&navpanes=0`}
                                    width="100%"
                                    style={{ border: 'none', height: '50rem' }}

                                />
                            )}
             
                          
                         {!loading && pdfBase64 && (client.isMobile() || client.isTablet()) && (
                            <div className='pdf-container' >
                             <Document
                             file={`data:application/pdf;base64,${pdfBase64}`}
                             onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                           >
                             {Array.from(new Array(numPages), (_, index) => (
                               <Page key={`page_${index + 1}`} pageNumber={index + 1} width={window.innerWidth - 40} />
                             ))}
                           </Document>
                           </div>
                        )}
                    </div>
            </div>
            {activeCheck && (
                        <div className='col-6'>
                            <div className="form-check pl-5 pt-4">
                            <input
                                checked={info.tcAcknowledgement === "1"}
                                value={info.tcAcknowledgement}
                                onClick={() => {
                                    setInfo({
                                        index: "tcAcknowledgement",
                                        value: info.tcAcknowledgement === "1" ? "0" : "1"
                                    });
                                }}
                                className="form-check-input"
                                type="checkbox"
                                {...register("tcAcknowledgement")}
                            />
                                <label className="form-check-label" htmlFor="termsPrices">
                                    By clicking this box, you agree that you have read the full terms and conditions of the {brandSettings.ProductName} Mastercard credit card offer.
                                </label>
                                {errors.tcAcknowledgement && 
                                    <div className="error-message"> You must agree before continue. </div>
                                }
                            </div>
                        </div>
                )}
                <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12 pt-3 ' style={{textAlign : (activeCheck) ? "center" : "left"}}>
                    <div className="terms-print">
                        <button type='button'  className="button-link" onClick={() => downloadPdf(pdfBase64, "terms_and_conditions.pdf")}>
                            <FontAwesomeIcon icon={faPrint} /> &nbsp; Rates, Fees, Costs and Limitations
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>

    );
}

export default TC;